import {
    Component,
    Input,
    OnChanges,
    OnDestroy,
    OnInit,
    Output,
    SimpleChanges
} from '@angular/core';
import { ReplaySubject } from 'rxjs';
import { EmployeeModel } from '../../../models/EmployeeModel';
import { MessageService, SelectItem } from '../../../shared';
import { LoggingService } from '../../../shared/services/logging';
import { takeWhile } from 'rxjs/operators';

@Component({
    selector: 'ef-send-hours-presenter',
    templateUrl: './send-hours-presenter.component.html',
    styleUrls: ['./send-hours-presenter.component.scss'],
    standalone: false
})
export class SendHoursPresenterComponent
    implements OnInit, OnDestroy, OnChanges
{
    @Input() public items: SelectItem[] = [];
    @Input() public sending = false;
    @Input() public progress: { current: number; total: number } | null = null;
    @Output() public SendHours = new ReplaySubject<SelectItem[]>(1);
    public selectedEmployees: SelectItem[];
    private active = true;
    constructor(
        private log: LoggingService,
        private messageService: MessageService
    ) {}
    ngOnChanges(changes: SimpleChanges): void {
        if (changes.items) {
            this.selectedEmployees = [];
        }
    }
    ngOnDestroy(): void {
        this.active = false;
    }

    ngOnInit(): void {
        this.SendHours.pipe(takeWhile(() => this.active)).subscribe(() => {
            this.log.debug('SendHoursPresenterComponent', 'SendHours');
        });
    }
    onSendHours(employees: SelectItem[]) {
        if (this.sending) {
            return;
        }
        this.log.verbose({
            type: 'SendHoursPresenterComponent:onSendHours',
            employees
        });
        this.SendHours.next(employees);
        this.selectedEmployees = [];
    }
}
